import React, { useContext } from 'react';
import classNames from 'classnames';
import { TrandingCardPlaceholder } from '../TrendingListingCard/placeholder';
import TrendingListingCard from '../TrendingListingCard';
import FireIcon from 'icons/Fire.icon';
import { useTranslation } from 'react-i18next';
import TrendingListingsContext from 'providers/TrendingListings/TrendingListings.context';

import './TrendingBusinesses.styles.scss';
import './TrendingBusinesses.styles.responsive.scss';

type TrendingBusinessesProps = {
  className?: string;
};

const TrendingBusinesses: React.FC<TrendingBusinessesProps> = (props) => {
  const { className } = props;

  const { loading, trendings } = useContext(TrendingListingsContext);

  const classes = classNames('trending-businesses', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <div className="trending-businesses__title">
        <p>{t('topTrendingListings')}</p>
        <FireIcon />
      </div>

      <div className="trending-businesses__content">
        {loading
          ? Array(4)
              .fill(1)
              .map((_, i) => <TrandingCardPlaceholder key={i} />)
          : trendings?.map((listing) => (
              <TrendingListingCard key={listing._id} {...listing} />
            ))}
      </div>
    </div>
  );
};

export default TrendingBusinesses;
